import { BRAND } from "../../types";

interface OrderFooterProps {
  baseTotal: number;
  insuranceCost: number;
  total: number;
  loading?: boolean;
  /** 去支付必须由上一页传入：在内部 `navigate` 并带上 `orderNo` / `type` 等 */
  onSubmit: () => void | Promise<void>;
}

export function OrderFooter({ baseTotal, insuranceCost, total, loading, onSubmit }: OrderFooterProps) {
  const handleSubmit = async () => {
    await onSubmit();
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white z-40"
      style={{ borderTop: "1px solid #F5F5F5", paddingTop: "12px", paddingBottom: "calc(12px + env(safe-area-inset-bottom, 0px))" }}
    >
      <div className="px-4 pt-3">
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="flex items-baseline gap-2">
              <div className="text-xs text-gray-400">订单金额</div>
              <span
                className="text-xl font-bold"
                style={{ color: "#EF4444" }}
              >
                ¥{baseTotal.toLocaleString()}
              </span>
            </div>
            {insuranceCost > 0 && (
              <div className="text-xs text-gray-400">
                含保险{" "}
                <span className="font-medium" style={{ color: "#10B981" }}>
                  +¥{insuranceCost}
                </span>{" "}
                · 合计{" "}
                <span className="font-bold text-gray-700">
                  ¥{total.toLocaleString()}
                </span>
              </div>
            )}
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-8 py-3.5 rounded-2xl text-sm font-bold text-white cursor-pointer whitespace-nowrap active:scale-[0.98] transition-all disabled:opacity-50"
            style={{
              background: `linear-gradient(135deg, ${BRAND}, #FF9A5C)`,
            }}
          >
            {loading ? "处理中..." : "去支付"}
          </button>
        </div>
      </div>
    </div>
  );
}
